(function () {
  var skript = document.currentScript;
  var W = (skript && skript.dataset) || {};
  var wort = function (k, f) { return W[k] || f; };
  var zwei = function (n) { return n < 10 ? '0' + n : String(n); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (z) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[z]; }); };

  function teile(rest) {
    var s = Math.floor(rest / 1000);
    var t = Math.floor(s / 86400); s -= t * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return [t, h, m, s];
  }

  function zeile(p) {
    var x = [];
    if (p[0] > 0) x.push(p[0] + ' ' + wort('tage', 'T'));
    x.push(zwei(p[1]) + ' ' + wort('std', 'Std'));
    x.push(zwei(p[2]) + ' ' + wort('min', 'Min'));
    x.push(zwei(p[3]) + ' ' + wort('sek', 'Sek'));
    return esc(wort('vor', 'endet in') + ' ' + x.join(' '));
  }

  function zellen(p, art) {
    var L = [wort('ktage', 'Tage'), wort('kstd', 'Std'), wort('kmin', 'Min'), wort('ksek', 'Sek')];
    var V = [p[0], zwei(p[1]), zwei(p[2]), zwei(p[3])];
    return V.map(function (v, i) {
      return '<span class="' + art + '"><b>' + v + '</b><small>' + esc(L[i]) + '</small></span>';
    }).join('');
  }

  function inhalt(el, p) {
    var form = el.getAttribute('data-form') || 'zeile';
    if (form === 'kacheln') return zellen(p, 'rc-k');
    var kurz = p[0] + ' ' + wort('tage', 'T') + ' ' + zwei(p[1]) + ':' + zwei(p[2]) + ':' + zwei(p[3]);
    if (form === 'anhang') return esc(wort('vor', 'endet in') + ' ' + kurz);
    if (form === 'kurz') return esc(kurz);
    return zeile(p);
  }

  function aufheben(el) {
    var bereich = el.closest('[data-rabatt-bereich]');
    if (el.hasAttribute('data-rabatt-ende-weg') && bereich) {
      bereich.hidden = true;
      var danach = bereich.parentNode && bereich.parentNode.querySelector('[data-rabatt-danach]');
      if (danach) danach.hidden = false;
    } else {
      el.textContent = wort('beendet', 'beendet');
    }
    el.removeAttribute('data-rabatt-ende');
    el.removeAttribute('data-rabatt-ende-iso');
  }

  function bisText(el) {
    var ende = Date.parse(el.getAttribute('data-rc-bis-iso')) - 1000;
    el.removeAttribute('data-rc-bis-iso');
    if (!ende) return;
    var d = new Date(ende);
    var teil = function (o) { return new Intl.DateTimeFormat('de-DE', Object.assign({ timeZone: 'Europe/Brussels' }, o)).format(d); };
    var datum = teil({ day: '2-digit' }) + '.' + teil({ month: '2-digit' }) + '.';
    var zeit = teil({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    el.textContent = wort('gilt', 'gilt bis %d, %z Uhr').replace('%d', datum).replace('%z', zeit);
  }

  function ticken() {
    var jetzt = Date.now();
    document.querySelectorAll('[data-rc-bis-iso]').forEach(bisText);
    document.querySelectorAll('[data-rabatt-ende], [data-rabatt-ende-iso]').forEach(function (el) {
      var ende = Number(el.getAttribute('data-rabatt-ende')) * 1000;
      if (!ende) {
        var iso = el.getAttribute('data-rabatt-ende-iso');
        ende = iso ? Date.parse(iso) : 0;
      }
      if (!ende) return;
      var rest = ende - jetzt;
      if (rest <= 0) { aufheben(el); return; }
      if (!el.hasAttribute('aria-label') && el.textContent.trim()) el.setAttribute('aria-label', el.textContent.trim().replace(/\s+/g, ' '));
      var neu = inhalt(el, teile(rest));
      if (el.__rc !== neu) { el.innerHTML = neu; el.__rc = neu; }
    });
  }

  window.rabattCountdown = ticken;
  ticken();
  setInterval(ticken, 1000);
})();
